export default __webpack_public_path__ + "static/media/logo_new.2df335d0.svg";